import React, { useEffect, useRef, useState } from 'react';
import Icon from './icons';

interface Props {
  onPick: (addr: string, zip: string) => void;
  onClose: () => void;
}

interface DaumData { zonecode: string; roadAddress: string; jibunAddress: string; buildingName?: string; }
interface DaumPostcodeCtor {
  new (o: { oncomplete: (d: DaumData) => void; width?: string | number; height?: string | number }): { embed: (el: HTMLElement) => void };
}
declare global { interface Window { daum?: { Postcode: DaumPostcodeCtor } } }

let loader: Promise<void> | null = null;
function loadScript(): Promise<void> {
  if (window.daum && window.daum.Postcode) return Promise.resolve();
  if (!loader) {
    loader = new Promise((res, rej) => {
      const s = document.createElement('script');
      s.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
      s.onload = () => res();
      s.onerror = () => { loader = null; rej(new Error('우편번호 서비스 로드 실패')); };
      document.head.appendChild(s);
    });
  }
  return loader;
}

/** 다음(카카오) 우편번호 서비스 — API 키 불필요, 선택 시 우편번호+도로명주소 반환 */
export default function ZipModal({ onPick, onClose }: Props) {
  const box = useRef<HTMLDivElement | null>(null);
  const cb = useRef(onPick);
  cb.current = onPick;
  const [err, setErr] = useState('');

  useEffect(() => {
    const k = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', k);
    return () => window.removeEventListener('keydown', k);
  }, [onClose]);

  useEffect(() => {
    let alive = true;
    loadScript().then(() => {
      if (!alive || !box.current || !window.daum) return;
      new window.daum.Postcode({
        oncomplete: (d) => {
          const road = d.roadAddress || d.jibunAddress || '';
          const addr = d.buildingName ? road + ' (' + d.buildingName + ')' : road;
          cb.current(addr, d.zonecode);
        },
        width: '100%', height: '100%',
      }).embed(box.current);
    }).catch((e) => { if (alive) setErr((e as Error).message); });
    return () => { alive = false; };
  }, []);

  return (
    <div className="ovm">
      <div className="ovbox" style={{ maxWidth: 520, width: '94%' }}>
        <div className="ovh"><b>우편번호 조회 · 도로명주소 검색</b><button className="povx" onClick={onClose}><Icon n="x" /> 닫기</button></div>
        {err
          ? <div className="snote" style={{ padding: '14px 4px' }}>{err} · 네트워크 확인 후 다시 열어주세요</div>
          : <div ref={box} style={{ height: 460, borderRadius: 10, overflow: 'hidden', border: '1px solid var(--line, #e5e9f2)' }} />}
        <div className="snote" style={{ marginTop: 8 }}>주소를 선택하면 우편번호와 도로명주소가 자동 입력됩니다.</div>
      </div>
    </div>
  );
}
